import { Component } from '@angular/core';
import { ButtonCallbackDto, ColumnDropdownDto } from 'webcommon/shared';
import { ApColumnBase } from './ap-column-base';

@Component({
  selector: 'ap-column-dropdown',
  templateUrl: './ap-column-dropdown.component.html',
})
export class ApColumnDropdownComponent extends ApColumnBase<ColumnDropdownDto> {
  dropdownList: ButtonCallbackDto[] = [];
  matIconName: string;

  load() {
    this.dropdownList = this.columnInfoDto.DropdownButtonList(this.dataItem);
    this.matIconName = this.columnInfoDto.DropdownIcon;
    return;
  }
}
